export enum PositionDeltaStatus {
  ACCEPT = 'Accept',
  IGNORE = 'Ignore',
  STANDBY = 'Standby'
}
